import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { Observable } from 'rxjs';
import { ResentOrdersPagination, RxHubIntegrationsResponse } from './rx-hub.model';

export { ResentOrder, RxHubCounts, RxHubIntegrationsResponse, ResentOrdersPagination } from './rx-hub.model';

export class RxHubService {
  private http = inject(HttpClient);
  private env = inject<PIMSEnvironment>(ENVIRONMENT);

  get(pagination: ResentOrdersPagination): Observable<RxHubIntegrationsResponse> {
    let params = new HttpParams();

    (Object.keys(pagination) as Array<keyof ResentOrdersPagination>).forEach(key => {
      const value = pagination[key];
      if (value !== undefined && value !== '') {
        params = params.set(key, String(value));
      }
    });

    return this.http.get<RxHubIntegrationsResponse>(
      `${this.env.constants.API_URL}/prxhub/integrations`,
      { params },
    );
  }

  put(dispenseOrderId: number, orderId: number): Observable<void> {
    return this.http.put<void>(
      `${this.env.constants.API_URL}/prxhub/dispenseorders/${dispenseOrderId}/orders/${orderId}/resend`,
      {},
    );
  }
}
